// extracted by mini-css-extract-plugin
module.exports = {"customHtml":"CustomHtml_customHtml__aaYGp"};